const __vite__mapDeps = (
  i,
  m = __vite__mapDeps,
  d = m.f ||
    (m.f = [
      "./dialog-ByNwXkEL.js",
      "./component-B88NZlIm.js",
      "./utilities-D-QcnR4L.js",
      "./events-CnaEWcY_.js",
      "./dialog-BwnPQ4b2.css",
      "./carousel-embla-DdNw28-H.js",
      "./embla-tQScX_QI.js",
      "./predictive-search-nzKpArE7.js",
      "./morph-Cxi7_pad.js",
    ])
) => i.map((i) => d[i]);
import "./liquid-ajax-cart-CD-8Lu3e.js";
import { C as h, b as A, c as L } from "./events-CnaEWcY_.js";
import { f as S } from "./utilities-D-QcnR4L.js";
const b = "modulepreload",
  T = function (n, e) {
    return new URL(n, e).href;
  },
  w = {},
  l = function (e, i, t) {
    let o = Promise.resolve();
    if (i && i.length > 0) {
      let x = function (s) {
        return Promise.all(
          s.map((u) =>
            Promise.resolve(u).then(
              (f) => ({ status: "fulfilled", value: f }),
              (f) => ({ status: "rejected", reason: f })
            )
          )
        );
      };
      const r = document.getElementsByTagName("link"),
        c = document.querySelector("meta[property=csp-nonce]"),
        q = c?.nonce || c?.getAttribute("nonce");
      o = x(
        i.map((s) => {
          if (((s = T(s, t)), s in w)) return;
          w[s] = !0;
          const u = s.endsWith(".css"),
            f = u ? '[rel="stylesheet"]' : "";
          if (t)
            for (let m = r.length - 1; m >= 0; m--) {
              const p = r[m];
              if (p.href === s && (!u || p.rel === "stylesheet")) return;
            }
          else if (document.querySelector(`link[href="${s}"]${f}`)) return;
          const d = document.createElement("link");
          if (
            ((d.rel = u ? "stylesheet" : b),
            u || (d.as = "script"),
            (d.crossOrigin = ""),
            (d.href = s),
            q && d.setAttribute("nonce", q),
            document.head.appendChild(d),
            u)
          )
            return new Promise((m, p) => {
              (d.addEventListener("load", m),
                d.addEventListener("error", () => p(new Error(`Unable to preload CSS for ${s}`))));
            });
        })
      );
    }
    function a(r) {
      const c = new Event("vite:preloadError", { cancelable: !0 });
      if (((c.payload = r), window.dispatchEvent(c), !c.defaultPrevented)) throw r;
    }
    return o.then((r) => {
      for (const c of r || []) c.status === "rejected" && a(c.reason);
      return e().catch(a);
    });
  };
let E = !1;
function P() {
  E ||
    ((E = !0),
    document.addEventListener("liquid-ajax-cart:init", () => {
      const n = window.liquidAjaxCart?.cart ?? null;
      document.dispatchEvent(
        new h(n, "liquid-ajax-cart:init", {
          source: "liquid-ajax-cart",
          itemCount: n?.item_count ?? 0,
        })
      );
    }),
    document.addEventListener("liquid-ajax-cart:request-end", (n) => {
      const { requestState: e } = n.detail,
        i = window.liquidAjaxCart?.cart ?? null;
      if (!e.responseData?.ok || e.fetchError) {
        const a = e.responseData?.body ?? {};
        document.dispatchEvent(
          new A(
            "liquid-ajax-cart",
            a.message ?? e.fetchError ?? "Cart request failed",
            a.description ?? null,
            a.errors ?? null
          )
        );
        return;
      }
      const o = {
        source: "liquid-ajax-cart",
        requestType: e.requestType,
        itemCount: i?.item_count ?? 0,
        sections: e.requestBody?.sections ?? null,
      };
      e.requestType === "add"
        ? document.dispatchEvent(new L(i, "liquid-ajax-cart", o))
        : document.dispatchEvent(new h(i, "liquid-ajax-cart", o));
    }));
}
let y = !1;
function j() {
  const e = document.querySelector("[data-engraving-fee-variant-id]")?.dataset
      .engravingFeeVariantId,
    i = e ? parseInt(e, 10) : NaN;
  return Number.isNaN(i) ? null : i;
}
function k(n) {
  if (!n.properties) return !1;
  const e = n.properties.Gravur ?? n.properties.Engraving ?? null;
  return typeof e == "string" && e.trim().length > 0;
}
async function D() {
  if (y) return;
  const n = j();
  if (!n) return;
  const e = window.liquidAjaxCart?.cart;
  if (!e?.items) return;
  const i = e.items.filter((r) => r.variant_id === n),
    o = e.items.filter((r) => r.variant_id !== n).filter(k).length;
  if (!(i.reduce((r, c) => r + c.quantity, 0) === o && i.length <= 1)) {
    y = !0;
    try {
      for (let c = 1; c < i.length; c++) await v(i[c].key, 0);
      const r = i[0];
      o === 0
        ? r && (await v(r.key, 0))
        : r
          ? r.quantity !== o && (await v(r.key, o))
          : await I(n, o);
    } finally {
      y = !1;
    }
  }
}
function v(n, e) {
  return new Promise((i) => {
    const t = new FormData();
    (t.append("id", n), t.append("quantity", String(e)));
    const o = (a) => {
      const { requestState: r } = a.detail ?? {};
      r?.requestType === "change" &&
        (document.removeEventListener("liquid-ajax-cart:request-end", o), i());
    };
    (document.addEventListener("liquid-ajax-cart:request-end", o), window.liquidAjaxCart.change(t));
  });
}
function I(n, e) {
  return new Promise((i) => {
    const t = new FormData();
    (t.append("items[0][id]", String(n)),
      t.append("items[0][quantity]", String(e)),
      t.append("items[0][properties][_type]", "engraving-fee"));
    const o = (a) => {
      const { requestState: r } = a.detail ?? {};
      r?.requestType === "add" &&
        (document.removeEventListener("liquid-ajax-cart:request-end", o), i());
    };
    (document.addEventListener("liquid-ajax-cart:request-end", o), window.liquidAjaxCart.add(t));
  });
}
function R() {
  document.querySelector("[data-engraving-fee-variant-id]") &&
    document.addEventListener("liquid-ajax-cart:request-end", (n) => {
      const { requestState: e } = n.detail ?? {};
      e?.responseData?.ok && (y || D());
    });
}
function V() {
  function n() {
    const e = j(),
      i = window.liquidAjaxCart?.cart;
    if (!i) return;
    let t = 0;
    e &&
      i.items &&
      (t = i.items.filter((a) => a.variant_id === e).reduce((a, r) => a + r.quantity, 0));
    const o = Math.max(0, i.item_count - t);
    document.querySelectorAll("[data-cart-visible-count]").forEach((a) => {
      a.textContent = o;
    });
  }
  document.addEventListener("liquid-ajax-cart:request-end", n);
}
function O() {
  if (!window.Shopify?.analytics?.publish) return;
  function n() {
    return window.liquidAjaxCart?.subscribeToCartAjaxRequests
      ? (window.liquidAjaxCart.subscribeToCartAjaxRequests((e) => {
          if (e.requestType !== "add" || e.requestState !== "end" || !e.responseData?.ok) return;
          (e.responseData.body?.items || []).forEach((t) => {
            window.Shopify.analytics.publish("product_added_to_cart", {
              cartLine: {
                quantity: t.quantity,
                merchandise: {
                  id: `gid://shopify/ProductVariant/${t.variant_id}`,
                  title: t.variant_title || t.title,
                  product: {
                    id: `gid://shopify/Product/${t.product_id}`,
                    title: t.product_title || t.title,
                    vendor: t.vendor,
                    type: t.product_type,
                    untranslatedTitle: t.product_title || t.title,
                    url: window.location.origin + t.url,
                  },
                  image: t.image ? { src: t.image } : void 0,
                  price: {
                    amount: t.price / 100,
                    currencyCode: window.Shopify?.currency?.active || "EUR",
                  },
                  sku: t.sku,
                  untranslatedTitle: t.variant_title || t.title,
                },
              },
            });
          });
        }),
        !0)
      : !1;
  }
  n() ||
    document.addEventListener("liquid-ajax-cart:init", () => {
      n();
    });
}
document.querySelector("[data-dialog], [data-modal]") &&
  l(
    () => import("./dialog-ByNwXkEL.js").then((n) => n.d),
    __vite__mapDeps([0, 1, 2, 3, 4]),
    import.meta.url
  );
document.querySelector("a[data-policy-modal]") &&
  l(() => import("./policy-modal-D91e2YU7.js"), [], import.meta.url);
document.readyState === "complete" ? g() : window.addEventListener("load", g);
function g() {
  document.querySelector("carousel-embla") &&
    l(() => import("./carousel-embla-DdNw28-H.js"), __vite__mapDeps([5, 1, 2, 6]), import.meta.url);
}
document.querySelector("[data-predictive-search], predictive-search-component") &&
  l(
    () => import("./predictive-search-nzKpArE7.js").then((n) => n.p),
    __vite__mapDeps([7, 1, 2, 8, 3]),
    import.meta.url
  );
document.querySelector(".kaching-bundles-deal-block-settings") &&
  l(() => import("./kaching-bundle-price-Z--iVqaA.js"), [], import.meta.url);
function _() {
  return window.liquidAjaxCart && typeof window.liquidAjaxCart.conf == "function"
    ? (window.liquidAjaxCart.conf("binderFormatters", { money: (n) => S(parseFloat(n)) }),
      window.liquidAjaxCart.conf("updateOnWindowFocus", !1),
      !0)
    : !1;
}
_() ||
  document.addEventListener("liquid-ajax-cart:init", () => {
    _();
  });
P();
R();
V();
O();
document.readyState === "complete" ? C() : window.addEventListener("load", C);
function C() {
  setTimeout(() => {
    l(() => import("./cart-analytics-DKpOu-jb.js"), [], import.meta.url);
  }, 1500);
}
(function () {
  const e = new Set();
  let i,
    t = null;
  document.addEventListener("mouseover", (o) => {
    const a = o.target.closest("a[href]");
    if (a === t || (clearTimeout(i), (t = a), !a)) return;
    const r = a.href;
    !r ||
      !r.startsWith(location.origin) ||
      e.has(r) ||
      (i = setTimeout(() => {
        const c = document.createElement("link");
        ((c.rel = "prefetch"), (c.href = r), document.head.appendChild(c), e.add(r));
      }, 200));
  });
})();
